import { html, render } from 'lit-html';
import { get, has, isNil, set, toNumber, unset } from 'lodash-es';
import { CONTROL, ROW } from './_tableTreeConsts';
export class TableTreeNode {
    static fromElement(element) {
        const level = toNumber(element.dataset[ROW.LEVEL]);
        const childrenCount = toNumber(get(element.dataset, ROW.CHILDREN_COUNT, '0'));
        const areChildrenLoaded = !has(element.dataset, ROW.LAZY) ||
            has(element.dataset, ROW.EXPANDED);
        const rowIdentifier = element.dataset[ROW.IDENTIFIER];
        return new TableTreeNode(level, childrenCount, rowIdentifier, areChildrenLoaded, element);
    }
    constructor(level, childrenCount, identifier, areChildrenLoaded, innerElement) {
        this.level = level;
        this.childrenCount = childrenCount;
        this.identifier = identifier;
        this.areChildrenLoaded = areChildrenLoaded;
        this.innerElement = innerElement;
        this.childControlElement = undefined;
        this.parentControlElement = undefined;
        this.pathElement = undefined;
        const childControl = innerElement.querySelector('div[name="child-control-container"]');
        // remove all controls and paths to rebuild them from scratch, for avoiding conflicting listeners on same events
        if (!isNil(childControl)) {
            childControl.remove();
        }
        const expanded = innerElement.querySelector('div[name="parent-expand"]');
        const collapsed = innerElement.querySelector('div[name="parent-collapse"]');
        if (!isNil(expanded)) {
            expanded.remove();
        }
        if (!isNil(collapsed)) {
            collapsed.remove();
        }
        const treePath = innerElement.querySelector('div[name="tree-path"]');
        if (!isNil(treePath)) {
            treePath.remove();
        }
    }
    get isExpanded() {
        return has(this.innerElement.dataset, ROW.EXPANDED);
    }
    get isHidden() {
        return has(this.innerElement.dataset, ROW.HIDDEN);
    }
    get innerElementHeight() {
        return this.innerElement.getBoundingClientRect().height;
    }
    get isChild() {
        return this.level > 0;
    }
    addStyleClass(styleClass) {
        this.innerElement.classList.add(styleClass);
    }
    removeStyleClass(styleClass) {
        this.innerElement.classList.remove(styleClass);
    }
    setTreePathHeight(height) {
        if (this.pathElement !== undefined) {
            this.pathElement.style.height = `${height}px`;
        }
    }
    addTreePath(hasChildren) {
        if (hasChildren && this.pathElement === undefined) {
            const pathControl = document.createElement('div');
            pathControl.setAttribute('name', 'tree-path');
            pathControl.classList.add(CONTROL.PATH);
            const firstElementChild = this.innerElement.firstElementChild;
            if (!isNil(firstElementChild)) {
                firstElementChild.prepend(pathControl);
                this.pathElement = pathControl;
            }
            else {
                console.error('could not find content for table data cell %o', this.innerElement);
            }
        }
    }
    addParentControls(toggle, shouldDisableCollapse) {
        if (this.parentControlElement === undefined &&
            !isNil(this.innerElement.firstElementChild)) {
            const collapseControl = document.createElement('div');
            collapseControl.classList.add(CONTROL.CLASS);
            collapseControl.classList.add(CONTROL.COLLAPSE);
            collapseControl.setAttribute('name', 'parent-collapse');
            const expandControl = document.createElement('div');
            expandControl.classList.add(CONTROL.CLASS);
            expandControl.classList.add(CONTROL.EXPAND);
            expandControl.setAttribute('name', 'parent-expand');
            render(html ` <sds-button-icon
                    @click="${toggle}"
                    type="secondary"
                    size="xs"
                    icon="minus"
                    ?disabled="${shouldDisableCollapse}"
                ></sds-button-icon>`, collapseControl);
            render(html ` <sds-button-icon
                    @click="${toggle}"
                    type="secondary"
                    size="xs"
                    icon="plus"
                ></sds-button-icon>`, expandControl);
            this.innerElement.firstElementChild.prepend(collapseControl, expandControl);
            this.parentControlElement = {
                expanded: expandControl,
                collapsed: collapseControl,
            };
        }
        else if (isNil(this.innerElement.firstElementChild)) {
            console.error('could not find content for table data cell %o', this.innerElement);
        }
    }
    expand() {
        set(this.innerElement.dataset, ROW.EXPANDED, '');
        this.areChildrenLoaded = true;
    }
    collapse() {
        unset(this.innerElement.dataset, ROW.EXPANDED);
    }
    hide() {
        set(this.innerElement.dataset, ROW.HIDDEN, '');
    }
    reveal() {
        unset(this.innerElement.dataset, ROW.HIDDEN);
    }
    addChildControls() {
        if (this.childControlElement === undefined &&
            !isNil(this.innerElement.firstElementChild)) {
            const childControl = document.createElement('div');
            childControl.classList.add(CONTROL.CLASS);
            if ('sum' === this.innerElement.dataset[ROW.AGGREGATED_TYPE]) {
                render(html ` <sds-icon size="16" name="sum"></sds-icon>`, childControl);
                childControl.classList.add(ROW.SUM_CLASS);
            }
            else {
                render(html ` <sds-icon size="16" name="radio_button"></sds-icon>`, childControl);
            }
            childControl.setAttribute('name', 'child-control-container');
            this.innerElement.firstElementChild.prepend(childControl);
            this.childControlElement = childControl;
        }
        else if (isNil(this.innerElement.firstElementChild)) {
            console.error('could not find content for table data cell %o', this.innerElement);
        }
    }
}
